export default [{
        path: '/poster',
        name: 'Poster',
        component: () => import('../../views/Park/Poster.vue'),
        meta: {
            title: '泊车收费海报',
            // keepAlive: true,
        }
    },
    {
        path: '/bindcar',
        name: 'Bindcar',
        component: () => import('../../views/Park/Bindcar.vue'),
        meta: {
            title: '绑定车牌号',
            // keepAlive: true,
        }
    },
    {
        path: '/fee',
        name: 'Fee',
        component: () => import('../../views/member/Fee.vue'),
        meta: {
            title: '',
            // keepAlive: true,
        }
    },
    {
        path: '/lease',
        name: 'Lease',
        component: () => import('../../views/member/Lease.vue'),
        meta: {
            title: '租赁信息',
            // keepAlive: true,
        }
    },
    {
        path: '/read',
        name: 'Read',
        component: () => import('../../views/member/Read.vue'),
        meta: {
            title: '缴费说明',
            // keepAlive: true,
        }
    },
    // {
    //     path: '/textd',
    //     name: 'Textd',
    //     component: () => import('../../views/Park/textd.vue'),
    //     meta: {
    //         title: '测试',
    //         keepAlive: false,
    //     }
    // },
    {
        path: '/activity',
        name: 'Activity',
        component: () => import('../../views/activity/Activity.vue'),
        meta: {
            title: '会员活动',
            keepAlive: false,
        }
    },
    {
        path: '/detailsM',
        name: 'DetailsM',
        component: () => import('../../views/activity/DetailsM.vue'),
        meta: {
            title: '活动详情',
            keepAlive: false,
        }
    },
    {
        path: '/actRecord',
        name: 'ActRecord',
        component: () => import('../../views/activity/ActRecord.vue'),
        meta: {
            title: '我的报名',
            keepAlive: false,
        }
    },
    {
        path: '/popUp',
        name: 'PopUp',
        component: () => import('../../views/pop/PopUp.vue'),
        meta: {
            title: 'Pop-Up-Store',
            keepAlive: false,
        }
    },
    {
        path: '/popDetails',
        name: 'PopDetails',
        component: () => import('../../views/pop/PopDetails.vue'),
        meta: {
            title: '快闪店详情',
            keepAlive: false,
        }
    },
    {
        path: '/record',
        name: 'Record',
        component: () => import('../../views/Park/Record.vue'),
        meta: {
            title: '缴费记录',
            keepAlive: false,
        }
    },
    {
        path: '/build',
        name: 'Build',
        component: () => import('../../views/Park/Build.vue'),
        meta: {
            title: '楼宇介绍',
            keepAlive: false,
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/park.js